import React from 'react';
export function HeroSection() {
  return <section className="relative pt-16 pb-0 md:pt-28 overflow-hidden bg-[#F5F1E8]" data-id="element-37">
      {/* Glow */}
      <div className="absolute top-[-100px] left-1/2 -translate-x-1/2 w-[600px] h-[400px] rounded-full pointer-events-none" style={{
      background: 'radial-gradient(circle, rgba(34,197,94,0.15) 0%, transparent 70%)'
    }} data-id="element-38" />

      <div className="max-w-4xl mx-auto px-4 relative z-10 text-center" data-id="element-39">
        {/* Brand */}
        <div className="animate-fade-in-up inline-flex items-center gap-2 px-5 py-2 rounded-full bg-white border border-green-200 text-green-600 text-sm font-bold tracking-wider mb-8 shadow-sm" data-id="element-40">
          <span className="w-2 h-2 rounded-full bg-green-500 animate-pulse" data-id="element-41" />
          MEGA PACK CETOSIS EXTREMA
        </div>

        {/* Headline */}
        <h1 className="animate-fade-in-up delay-100 text-4xl sm:text-5xl md:text-7xl font-extrabold text-green-900 leading-[1.08] tracking-tight mb-6" data-id="element-42">
          Bajá de peso con keto argentino real.
          <br data-id="element-43" />
          <span className="text-green-600" data-id="element-44">En 21 días — Sin pasar hambre</span>
        </h1>

        {/* Product Mockup */}
        <div className="animate-fade-in-up delay-150 flex justify-center mb-8" data-id="element-45">
          <img src="https://cdn.magicpatterns.com/uploads/rskDMzNATUGaazUr3tVBrh/mockup_listo_cetosis_-_Editado.png" alt="Mega Pack Cetosis Extrema 21 Días — El pack más completo de keto en Argentina" className="w-full max-w-md md:max-w-lg drop-shadow-2xl" data-id="element-46" />
        </div>

        {/* Product Card */}
        <div className="animate-fade-in-up delay-200 bg-white border border-green-200 rounded-2xl p-6 md:p-8 mb-8 relative overflow-hidden shadow-lg" data-id="element-47">
          <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-green-600 via-green-400 to-green-600" data-id="element-48" />
          <h2 className="text-xl md:text-3xl font-bold text-green-900 mb-3" data-id="element-49">
            MEGA PACK CETOSIS EXTREMA 21 DÍAS
          </h2>
          <p className="text-base md:text-lg text-green-600 font-semibold mb-4" data-id="element-50">
            El sistema N°1 para bajar de peso con keto en Argentina — Sin
            ingredientes imposibles — Sin pasar hambre — Sin perder los domingos
            cocinando
          </p>
          <p className="text-slate-700 text-base md:text-lg leading-relaxed max-w-3xl mx-auto" data-id="element-51">
            Recetas criollas + protocolo de 21 días + ingredientes de almacén +
            plan completo. Sin harina de almendras. Sin productos importados.
            Sin abandonar el asado del domingo.
          </p>
        </div>

        {/* Badges */}
        <div className="animate-fade-in-up delay-300 flex flex-wrap justify-center gap-2 md:gap-3 mb-10" data-id="element-52">
          {['📄 100% PDF', '⚡ Acceso en 5 min', '🇦🇷 Hecho para Argentina', '🥩 Ingredientes de almacén', '🔒 Pago seguro'].map((b, i) => <span key={i} className="px-3 py-1.5 md:px-4 md:py-2 rounded-lg bg-white text-slate-700 text-xs md:text-sm font-medium border border-green-100 shadow-sm" data-id="element-53">
              {b}
            </span>)}
        </div>

        {/* CTA */}
        <div className="animate-fade-in-up delay-400 flex flex-col items-center mb-16" data-id="element-54">
          <a href="#pricing" className="animate-pulse-glow inline-flex items-center justify-center w-full sm:w-auto px-10 py-5 text-lg md:text-xl font-bold text-white bg-green-600 hover:bg-green-500 rounded-xl transition-all active:scale-95 shadow-lg" data-id="element-55">
            → QUIERO MI MEGA PACK AHORA
          </a>
          <div className="flex flex-wrap justify-center items-center gap-3 md:gap-4 mt-5 text-xs md:text-sm font-medium text-slate-600" data-id="element-56">
            <span data-id="element-57">🛡️ Garantía 7 días</span>
            <span className="hidden sm:inline text-green-200" data-id="element-58">|</span>
            <span data-id="element-59">🔒 Pago seguro</span>
            <span className="hidden sm:inline text-green-200" data-id="element-60">|</span>
            <span data-id="element-61">💳 Mercado Pago</span>
          </div>
        </div>
      </div>

      {/* Stats Bar */}
      <div className="animate-fade-in delay-600 border-y border-green-200 bg-white/60 backdrop-blur-sm" data-id="element-62">
        <div className="max-w-5xl mx-auto px-4" data-id="element-63">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-y-6 py-8 md:py-10" data-id="element-64">
            {[{
            val: '+800',
            label: 'personas ya lo están usando'
          }, {
            val: '6',
            label: 'Tomos completos'
          }, {
            val: '6',
            label: 'Bonos incluidos'
          }, {
            val: '4.9/5 ★',
            label: 'calificación'
          }].map((s, i) => <div key={i} className="text-center px-4" data-id="element-65">
                <div className="text-2xl md:text-4xl font-bold text-green-900 mb-1" data-id="element-66">
                  {s.val}
                </div>
                <div className="text-[11px] md:text-sm text-slate-600 font-medium uppercase tracking-wider" data-id="element-67">
                  {s.label}
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}